import { View } from 'foundations-components/components/View';
import unescapedText from 'I18n/utils/unescapedText';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { EcosystemSlider } from 'trellis-ecosystem';
import { CollectionCard } from '../../collections/components/CollectionCard';
import { Subscreens } from '../../constants/usage';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { useFormatRecommendedPartners } from '../hooks/useFormatRecommendedPartners';
import { jsx as _jsx } from "react/jsx-runtime";
export function RecommendedPartners() {
  const scrollToTop = useScrollToTop();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const {
    data: recommendedPartners,
    loading
  } = useFormatRecommendedPartners();
  if (loading || !(recommendedPartners !== null && recommendedPartners !== void 0 && recommendedPartners.length)) {
    return null;
  }
  const trackSliderButtonClicked = direction => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: `recommended partners section ${direction} arrow clicked`,
      // Hardcoded index based on figma design layout
      itemIndex: 3,
      subscreen: Subscreens.RECOMMENDED_PARTNERS
    }));
  };
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "1000",
    maxInlineSize: "100%",
    children: /*#__PURE__*/_jsx(EcosystemSlider, {
      cardWidth: 625,
      gradientColor: "fill-surface-recessed",
      onScrollButtonClick: trackSliderButtonClicked
      // I've eyeballed this so the center of the scroll buttons aligns with the bottom of the card image background
      ,
      scrollButtonTop: "43.5%",
      title: unescapedText('marketplaceStorefront.recommendedPartners.title'),
      children: recommendedPartners === null || recommendedPartners === void 0 ? void 0 : recommendedPartners.map(({
        recommendationKey,
        translatedValue,
        value
      }) => /*#__PURE__*/_jsx(CollectionCard, {
        name: unescapedText(`marketplaceStorefront.recommendedPartners.card.${recommendationKey}.title`, {
          [recommendationKey]: translatedValue
        }),
        description: unescapedText(`marketplaceStorefront.recommendedPartners.card.${recommendationKey}.subtitle`, {
          [recommendationKey]: translatedValue
        }),
        buttonText: unescapedText('marketplaceStorefront.recommendedPartners.card.buttonText'),
        slug: `solutions?${recommendationKey}=${value}`,
        href: `solutions?${recommendationKey}=${value}`,
        onClick: () => {
          trackMarketplaceEvent(getMarketplaceInteractionEvent({
            action: 'recommended partners card clicked',
            category: recommendationKey,
            subscreen: Subscreens.RECOMMENDED_PARTNERS
          }));
          scrollToTop();
        }
      }, recommendationKey))
    })
  });
}